document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    const targetId = anchor.getAttribute('href')
    if (targetId === '#') return

    anchor.addEventListener('click', e => {
      e.preventDefault()

      const target = document.querySelector(targetId)
      if (!target) return

      const header = document.querySelector('#header')
      const headerHeight = header ? header.offsetHeight : 0

      const offset = headerHeight + 20

      const top = target.getBoundingClientRect().top

      window.scrollTo({
        top: window.scrollY + top - offset,
        behavior: 'smooth'
      })
    })
  })
})